<template>
  <div class="filters" :class="{ active: active, open: drawerOpen }">
    <h2>{{ $route.name !== 'map' ? 'Sort By' : 'Filter By'}} <span>{{ $parent.artists.length }} results</span></h2>

    <div class="filters-content">
      <template v-if="$route.name !== 'map'">
        <div class="filter-group">
          <div class="filters-list">
            <button class="filter" @click="sort('tour_number')" :class="{ active: $parent.selectedSort.indexOf('tour_number') > -1 }">Tour Number</button>
            <button class="filter" @click="sort('alphabetical')" :class="{ active: $parent.selectedSort.indexOf('alphabetical') > -1 }">Alphabetical</button>
            <button v-if="$root.currentPosition.length" class="filter" @click="sort('nearest')" :class="{ active: $parent.selectedSort.indexOf('nearest') > -1 }">Nearest to you</button>
          </div>
        </div>
      </template>

      <h2 v-if="$route.name !== 'map'">Filter By</h2>
      <div v-if="$root.app" class="filter-group">
        <h3>Favorites</h3>
        <div class="filters-list">
          <button class="filter" @click="filterFavorites()" :class="{ active: $parent.showFavorites }">FAVORITES</button>
          <button class="filter" @click="filterEverything()" :class="{ active: !$parent.showFavorites }">EVERYTHING ELSE</button>
        </div>
      </div>

      <div class="filter-group">
        <h3>Side</h3>
        <div class="filters-list">
          <button class="filter" @click="filterBySide('EAST')" :class="{ active: $parent.selectedSide.indexOf('EAST') > -1 }">EAST</button>
          <button class="filter" @click="filterBySide('WEST')" :class="{ active: $parent.selectedSide.indexOf('WEST') > -1 }">WEST</button>
        </div>
      </div>
      <div class="filter-group">
        <h3>Category</h3>
        <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
          <button v-for="option in $root.artistsSchema.type.enum" :key="option" class="filter" @click="filterByType(option)" :class="{ active: $parent.selectedTypes.indexOf(option) > -1 }">{{option}}</button>
        </div>
      </div>
      <div class="filter-group">
        <h3>Practice</h3>
        <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
          <button v-for="option in $root.artistsSchema.practice.enum" :key="option" class="filter" @click="filterByPractice(option)" :class="{ active: $parent.selectedPractice.indexOf(option) > -1 }">{{option}}</button>
        </div>
      </div>
      <div class="filter-group">
        <h3>Medium</h3>
        <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
          <button v-for="option in $root.artistsSchema.artwork.items.properties.mediums.items.enum" :key="option" class="filter" @click="filterByMedium(option)" :class="{ active: $parent.selectedMediums.indexOf(option) > -1 }">{{option}}</button>
        </div>
      </div>
      <div class="filter-group">
        <h3>Subject</h3>
        <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
          <button v-for="option in $root.artistsSchema.artwork.items.properties.subject.items.enum" :key="option" class="filter" @click="filterBySubject(option)" :class="{ active: $parent.selectedSubjects.indexOf(option) > -1 }">{{option}}</button>
        </div>
      </div>
      <div class="filter-group">
        <h3>Palette</h3>
        <div class="filters-list">
          <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
            <button v-for="option in $root.artistsSchema.artwork.items.properties.palette.items.enum" :key="option" class="filter" @click="filterByPalette(option)" :class="{ active: $parent.selectedPalettes.indexOf(option) > -1 }">{{option}}</button>
          </div>
        </div>
      </div>
      <div class="filter-group">
        <h3>Accessibility</h3>
        <div class="filters-list">
          <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
            <button class="filter" @click="filterByA11y('parking')" :class="{ active: $parent.selectedA11y.indexOf('parking') > -1 }">Parking for Disabled</button>
            <button class="filter" @click="filterByA11y('mobility')" :class="{ active: $parent.selectedA11y.indexOf('mobility') > -1 }">Mobility</button>
            <button class="filter" @click="filterByA11y('restrooms')" :class="{ active: $parent.selectedA11y.indexOf('restrooms') > -1 }">Restrooms</button>
            <button class="filter" @click="filterByA11y('other')" :class="{ active: $parent.selectedA11y.indexOf('other') > -1 }">Braille</button>
            <button class="filter" @click="filterByA11y('family')" :class="{ active: $parent.selectedA11y.indexOf('family') > -1 }">Family Friendly</button>
          </div>
        </div>
      </div>
      <div class="filter-group">
        <h3>Affiliation</h3>
        <div class="filters-list">
          <div class="filters-list">
            <button class="filter" @click="filterByAffiliation('Austin Community College')" :class="{ active: $parent.selectedAffiliations.indexOf('Austin Community College') > -1 }">Austin Community College</button>
          </div>
        </div>
      </div>
      <div class="filter-group">
        <h3>Themed Tour</h3>
        <div class="filters-list">
          <div class="filters-list" v-if="'artwork' in $root.artistsSchema">
            <button v-for="option in $root.artistsSchema.themed_tour.items.enum" :key="option" class="filter" @click="filterByThemedTour(option)" :class="{ active: $parent.selectedThemedTours.indexOf(option) > -1 }">{{option}}</button>
          </div>
        </div>
      </div>
    </div>

    <button class="btn" v-on:click="closeDrawer">Close</button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: false,
      activeTimeout: null,
      drawerOpen: false,
    }
  },
  methods: {
    filterUpdate() {
      this.$parent.filtersChanged();
    },
    filterBySide(by) {
      this.$parent.selectedSide = this.$parent.selectedSide === by ? '' : by;

      this.filterUpdate();
    },
    filterByType(by) {
      if (this.$parent.selectedTypes.indexOf(by) > -1) {
        this.$parent.selectedTypes.splice(this.$parent.selectedTypes.indexOf(by), 1);
      } else {
        this.$parent.selectedTypes.push(by);
      }

      this.filterUpdate();
    },
    filterByPractice(by) {
      if (this.$parent.selectedPractice.indexOf(by) > -1) {
        this.$parent.selectedPractice.splice(this.$parent.selectedPractice.indexOf(by), 1);
      } else {
        this.$parent.selectedPractice.push(by);
      }

      this.filterUpdate();
    },
    filterByMedium(by) {
      if (this.$parent.selectedMediums.indexOf(by) > -1) {
        this.$parent.selectedMediums.splice(this.$parent.selectedMediums.indexOf(by), 1);
      } else {
        this.$parent.selectedMediums.push(by);
      }

      this.filterUpdate();
    },
    filterBySubject(by) {
      if (this.$parent.selectedSubjects.indexOf(by) > -1) {
        this.$parent.selectedSubjects.splice(this.$parent.selectedSubjects.indexOf(by), 1);
      } else {
        this.$parent.selectedSubjects.push(by);
      }

      this.filterUpdate();
    },
    filterByPalette(by) {
      if (this.$parent.selectedPalettes.indexOf(by) > -1) {
        this.$parent.selectedPalettes.splice(this.$parent.selectedPalettes.indexOf(by), 1);
      } else {
        this.$parent.selectedPalettes.push(by);
      }

      this.filterUpdate();
    },
    filterByA11y(by) {
      if (this.$parent.selectedA11y.indexOf(by) > -1) {
        this.$parent.selectedA11y.splice(this.$parent.selectedA11y.indexOf(by), 1);
      } else {
        this.$parent.selectedA11y.push(by);
      }

      this.filterUpdate();
    },
    filterByAffiliation(by) {
      if (this.$parent.selectedAffiliations.indexOf(by) > -1) {
        this.$parent.selectedAffiliations.splice(this.$parent.selectedAffiliations.indexOf(by), 1);
      } else {
        this.$parent.selectedAffiliations.push(by);
      }

      this.filterUpdate();
    },
    filterFavorites() {
      this.filterUpdate();
      this.$parent.showFavorites = true;
    },
    filterEverything() {
      this.filterUpdate();
      this.$parent.showFavorites = false;
    },
    filterByThemedTour(by) {
      if (this.$parent.selectedThemedTours.indexOf(by) > -1) {
        this.$parent.selectedThemedTours.splice(this.$parent.selectedThemedTours.indexOf(by), 1);
      } else {
        this.$parent.selectedThemedTours.push(by);
      }

      this.filterUpdate();
    },
    sort(by) {
      this.$parent.selectedSort = this.$parent.selectedSort === by ? '' : by;
      this.filterUpdate();
    },
    openDrawer() {
      clearTimeout(this.activeTimeout);
      this.active = true;
      document.body.classList.add('stop-scroll');
      setTimeout(() => {
        this.drawerOpen = true;
      }, 50);
    },
    closeDrawer() {
      this.drawerOpen = false;
      document.body.classList.remove('stop-scroll');
      this.activeTimeout = setTimeout(() => {
        this.active = false;
      }, 500);
    },
  },
};
</script>

<style src="../css/Filters.less" scoped lang="less"></style>



// WEBPACK FOOTER //
// src/components/Filters.vue